import React, { useEffect, useState } from "react";
import "./DataTableDepartments.scss";
import { Space, Input, Popover } from "antd";
import type { ColumnsType } from "antd/es/table";
import { useNavigate } from "react-router-dom";
import { AppTable } from "../common";

interface Contentdata {
  key?: string;
  _id: number;
  name?: string;
  color?: string;
}

interface DataTableProps {
  setshowModel: (value: boolean) => void;
  deleteDepartment: any;
  isOpen: boolean;
  contentData: Contentdata[];
}

function DataTableDepartments({
  contentData,
  deleteDepartment,
  action,
}: DataTableProps & { action?: React.ReactNode }) {
  const navigate = useNavigate();
  const [searchText, setSearchText] = useState("");
  const [openPopId, setOpenPopId] = useState<any>(null);

  useEffect(() => {
    console.log(contentData, "dfsdfsd");
  }, [contentData]);

  const columns: ColumnsType<Contentdata> = [
    {
      title: "ID",
      dataIndex: "_id",
      key: "_id",
       width:250,
      filteredValue: [searchText],
      defaultSortOrder: "descend",
      sorter: (a: any, b: any) => a._id.localeCompare(b._id),
      ellipsis: true,
      onFilter: (value, record) => {
        return (
          String(record._id).toLowerCase().includes(value.toLocaleString()) ||
          String(record.name).toLowerCase().includes(value.toLocaleString()) ||
          String(record.name).toLowerCase().includes(value.toLocaleString())
        );
      },
      render: (val) => <span>{val?.toString()}</span>,
    },
    {
      title: "Department Name",
      dataIndex: "name",
      width:250,
      sorter: (a: any, b: any) => a.name.localeCompare(b.name),
      render: (name, record) => (
        <div className="deptable__name-cell">
          <span
            className="deptable__color-dot"
            style={{ background: record.color || "#b21e49" }}
          />
          <span className="deptable__name">{name}</span>
        </div>
      ),
    },
    // {
    //   title: "Color",
    //   dataIndex: "color",
    //   key: "color",
    //   width: 120,
    //   render: (color) => (
    //     <div className="deptable__color-cell">
    //       <span
    //         className="deptable__color-swatch"
    //         style={{ background: color }}
    //       />
    //       <span className="deptable__color-hex">{color}</span>
    //     </div>
    //   ),
    // },
    {
      title: "Actions",
      key: "action",
      width: 160,
      render: (_, record) => (
        <Space size={8}>
          {/* Edit */}
          <button
            className="deptable__btn deptable__btn--edit"
            onClick={() => navigate(`/editdepartments?did=${record._id}`)}
          >
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
              <path
                d="M8.5 1.5a1.414 1.414 0 012 2L4 10H2V8L8.5 1.5z"
                stroke="currentColor"
                strokeWidth="1.3"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            Edit
          </button>

          {/* Delete with confirm popover */}
          <Popover
            open={openPopId === record._id}
            onOpenChange={(v) => setOpenPopId(v ? record._id : null)}
            trigger="click"
            placement="topRight"
            overlayClassName="deptable-popover"
            title={null}
            content={
              <div className="deptable-pop">
                <div className="deptable-pop__icon">🗑️</div>
                <p className="deptable-pop__msg">
                  Do you really want to delete this department?<br />
                  <span>This action cannot be undone.</span>
                </p>
                <div className="deptable-pop__btns">
                  <button
                    className="deptable-pop__btn deptable-pop__btn--confirm"
                    onClick={() => {
                      deleteDepartment(record?.name);
                      setOpenPopId(null);
                    }}
                  >
                    Yes, Delete
                  </button>
                  <button
                    className="deptable-pop__btn deptable-pop__btn--cancel"
                    onClick={() => setOpenPopId(null)}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            }
          >
            <button className="deptable__btn deptable__btn--delete">
              <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                <path
                  d="M1.5 3h9M4.5 3V1.5h3V3M3.5 3l.5 7.5h4l.5-7.5"
                  stroke="currentColor"
                  strokeWidth="1.3"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              Delete
            </button>
          </Popover>
        </Space>
      ),
    },
  ];

  return (
    <div className="deptable">
      <div className="filterMenu">
        {action}
        <Input.Search
          onSearch={(value) => {
            setSearchText(value);
          }}
          onChange={(e) => {
            setSearchText(e.target.value);
          }}
          className="searchField"
          placeholder="Search here..."
        />
      </div>

      <AppTable
        className="deptable__grid"
        columns={columns}
        dataSource={contentData}
        rowKey="_id"
      />
    </div>
  );
}

export default DataTableDepartments;
